exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-color:#09031f}body .content-container{position:absolute;top:50px;left:50px;right:180px;padding:36px;padding-top:0;border-radius:4px;background-color:hsla(0,0%,100%,.8);overflow:auto}.ui-wrap #bg_magic_circle{opacity:.12}@media (max-width:770px){#wrap.ui-wrap .content-container{position:static;width:100%;border-radius:0}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./examples/ui.less
 ** module id = 50
 ** module chunks = 0
 **/